export const TIMED_OUT = Symbol("timed out")

/**
 * Bound a promise without cancelling its underlying work. The caller can
 * decide whether a timeout is a recoverable fallback or a terminal failure.
 */
export const withTimeout = async <T, TTimeout = typeof TIMED_OUT>(
  promise: Promise<T>,
  timeoutMs: number,
  onTimeout: () => TTimeout = () => TIMED_OUT as TTimeout,
): Promise<T | TTimeout> => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined
  const timeout = new Promise<TTimeout>((resolve) => {
    timeoutId = setTimeout(() => resolve(onTimeout()), timeoutMs)
  })

  try {
    return await Promise.race([promise, timeout])
  } finally {
    if (timeoutId !== undefined) clearTimeout(timeoutId)
  }
}
